/**
 * training-group-add.js
 */

import React from 'react';
import { 
  useMediaQuery,
  Tooltip,
} from '@mui/material';
import { useHistory, Link } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import DropMenu from 'components/drop-menu';
import AddGroupDialog from '../add-group-dialog';
import { ConnectedHandlersContext } from '../connections/connected-handlers-context';
import { TrainingGroupsContext } from './training-groups-context';
import { trainingGroupRoute } from './training-groups';


export default function TrainingGroupAdd(props) {
  const { menuLabel } = props;
  const { user } = React.useContext(UserContext);
  const { onCreateRequest } = React.useContext(TrainingGroupsContext);
  const { managedHandlerIds } = React.useContext(ConnectedHandlersContext);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const history = useHistory();
  const [isJoinDialogOpen, setIsJoinDialogOpen] = React.useState(false);
  const isInvalidTrainer = user.role.isTrainer && managedHandlerIds?.length === 0;
  const menuButton = React.cloneElement(menuLabel, { 
    disabled: isInvalidTrainer, 
    style: !isInvalidTrainer && isMobile ? { color: 'inherit' } : {} 
  });
  const items = (() => {
    const items = [{
      key: 'add',
      name: 'Create Group',
      icon: 'group-training',
      component: Link,
      to: trainingGroupRoute(0, history),
    }];
    if (user.role.isHandler) {
      items.push({
        key: 'join',
        name: 'Join Group ...',
        icon: 'group-add-members',
        onSelect: () => setIsJoinDialogOpen(true)
      });
    }
    return items;
  })();


  return (
    <>
      <Tooltip arrow placement='top' title={isInvalidTrainer ? 'You must be training at least one handler to create a training group' : ''}>
        <span>
          <DropMenu
            label={menuButton}
            anchorOrigin={{
              vertical: isMobile ? 'top' : 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            items={items}
          />
        </span>
      </Tooltip>

      <AddGroupDialog
        title='Join Training Group'
        text={`A group code contains 7 letters and numbers. If you know the code of the group that you want to join then type it below. The leaders of the group will be notified.`}
        inputLabel='Group Code'
        isOpen={isJoinDialogOpen}
        onClose={() => setIsJoinDialogOpen(false)}
        onOk={async (groupCode) => {
          const ret = await onCreateRequest(groupCode);
          if (ret === true) {
            setIsJoinDialogOpen(false);
          }
          return ret;
        }}
      />
    </>
  )
}